import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, GroupComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-add-evaluation-dropdown-footer',
  templateUrl: './add-evaluation-dropdown-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, GroupComponent, ButtonComponent],
})
export class AddEvaluationDropdownFooterComponent {
  public readonly isFormValid = input.required<boolean>();

  public cancel = output<void>();
  public submit = output<void>();
}
